// Textos do Início da Farm (02/11/2026), coletados por glob em core/i18n/messages.ts.
export default {
  pt: {
    'farm.inicio.titulo': 'Início',
    'farm.inicio.bomDia': 'Bom dia, {{nome}}',
    'farm.inicio.boaTarde': 'Boa tarde, {{nome}}',
    'farm.inicio.boaNoite': 'Boa noite, {{nome}}',
    'farm.inicio.tudoEmDia': 'Tudo em dia',
    'farm.inicio.pedemAtencao': '{{n}} obrigações pedem atenção',
    'farm.inicio.umaPedeAtencao': '1 obrigação pede atenção',
    'farm.inicio.toqueNoImovel': 'Toque num imóvel para abrir a ficha',
    'farm.inicio.kpi.imoveis': 'Imóveis',
    'farm.inicio.kpi.hectares': 'Hectares',
    'farm.inicio.kpi.vence30': 'Vencem em 30 dias',
    'farm.inicio.kpi.atrasadas': 'Atrasadas',
    'farm.inicio.kpi.documentos': 'Documentos vencendo',
    'farm.inicio.kpi.currais': 'Currais ocupados',
    'farm.inicio.kpi.equipe': 'Equipe',
    'farm.inicio.dica.hectares': 'A soma das escrituras',
    'farm.inicio.dica.documentos': '{{n}} já vencidos, os demais em 60 dias',
    'farm.inicio.dica.currais': '{{n}} cabeças no confinamento',
    'farm.inicio.proximos': 'Próximos vencimentos',
    'farm.inicio.verAgenda': 'Ver agenda',
    'farm.inicio.nadaVencendo': 'Nada vencendo por agora.',
    'farm.inicio.osImoveis': 'Os imóveis',
    'farm.inicio.verImoveis': 'Ver imóveis',
    'farm.inicio.hectares': 'Hectares',
    'farm.inicio.equipe': 'Equipe',
    'farm.inicio.pendencias': 'Pendências',
    'farm.inicio.semLancamento': 'Sem lançamento',
    'farm.inicio.erro': 'Não deu para carregar o Início.',
    'farm.inicio.tentarDeNovo': 'Tentar de novo',
  },
  en: {
    'farm.inicio.titulo': 'Home',
    'farm.inicio.bomDia': 'Good morning, {{nome}}',
    'farm.inicio.boaTarde': 'Good afternoon, {{nome}}',
    'farm.inicio.boaNoite': 'Good evening, {{nome}}',
    'farm.inicio.tudoEmDia': 'All on track',
    'farm.inicio.pedemAtencao': '{{n}} obligations need attention',
    'farm.inicio.umaPedeAtencao': '1 obligation needs attention',
    'farm.inicio.toqueNoImovel': 'Tap a property to open its record',
    'farm.inicio.kpi.imoveis': 'Properties',
    'farm.inicio.kpi.hectares': 'Hectares',
    'farm.inicio.kpi.vence30': 'Due in 30 days',
    'farm.inicio.kpi.atrasadas': 'Overdue',
    'farm.inicio.kpi.documentos': 'Expiring documents',
    'farm.inicio.kpi.currais': 'Pens in use',
    'farm.inicio.kpi.equipe': 'Team',
    'farm.inicio.dica.hectares': 'The sum of the deeds',
    'farm.inicio.dica.documentos': '{{n}} already expired, the others within 60 days',
    'farm.inicio.dica.currais': '{{n}} head in the feedlot',
    'farm.inicio.proximos': 'Upcoming due dates',
    'farm.inicio.verAgenda': 'Open calendar',
    'farm.inicio.nadaVencendo': 'Nothing due for now.',
    'farm.inicio.osImoveis': 'The properties',
    'farm.inicio.verImoveis': 'Open properties',
    'farm.inicio.hectares': 'Hectares',
    'farm.inicio.equipe': 'Team',
    'farm.inicio.pendencias': 'Pending',
    'farm.inicio.semLancamento': 'No entries',
    'farm.inicio.erro': 'Could not load Home.',
    'farm.inicio.tentarDeNovo': 'Try again',
  },
  es: {
    'farm.inicio.titulo': 'Inicio',
    'farm.inicio.bomDia': 'Buenos días, {{nome}}',
    'farm.inicio.boaTarde': 'Buenas tardes, {{nome}}',
    'farm.inicio.boaNoite': 'Buenas noches, {{nome}}',
    'farm.inicio.tudoEmDia': 'Todo al día',
    'farm.inicio.pedemAtencao': '{{n}} obligaciones piden atención',
    'farm.inicio.umaPedeAtencao': '1 obligación pide atención',
    'farm.inicio.toqueNoImovel': 'Toque un inmueble para abrir la ficha',
    'farm.inicio.kpi.imoveis': 'Inmuebles',
    'farm.inicio.kpi.hectares': 'Hectáreas',
    'farm.inicio.kpi.vence30': 'Vencen en 30 días',
    'farm.inicio.kpi.atrasadas': 'Atrasadas',
    'farm.inicio.kpi.documentos': 'Documentos por vencer',
    'farm.inicio.kpi.currais': 'Corrales ocupados',
    'farm.inicio.kpi.equipe': 'Equipo',
    'farm.inicio.dica.hectares': 'La suma de las escrituras',
    'farm.inicio.dica.documentos': '{{n}} ya vencidos, los demás en 60 días',
    'farm.inicio.dica.currais': '{{n}} cabezas en el engorde',
    'farm.inicio.proximos': 'Próximos vencimientos',
    'farm.inicio.verAgenda': 'Ver agenda',
    'farm.inicio.nadaVencendo': 'Nada por vencer por ahora.',
    'farm.inicio.osImoveis': 'Los inmuebles',
    'farm.inicio.verImoveis': 'Ver inmuebles',
    'farm.inicio.hectares': 'Hectáreas',
    'farm.inicio.equipe': 'Equipo',
    'farm.inicio.pendencias': 'Pendientes',
    'farm.inicio.semLancamento': 'Sin registros',
    'farm.inicio.erro': 'No se pudo cargar el Inicio.',
    'farm.inicio.tentarDeNovo': 'Intentar de nuevo',
  },
}
